<template>
  <div class="scroll-wrapper" @scroll="rememberPos" ref="scrollList">
 <slider animation="fade" :height="bannerHeight" v-if="bannerStatus&&(channelId==0)">
          <slider-item v-for="(item, index) in bannerLists" :key="index" >
            <img :src="item.img_url" @click="bannerTo(item.jump_url)"  width="100%" :height="bannerHeight"/>
          </slider-item>
        </slider>

    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      loosing-text="即将刷新"
      loading-text="刷新中..."
      success-text="加载完毕"
      ref="refresh"
    >
      <!-- 标签一 -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
         :immediate-check="false"
        @load="onLoad"
      >
        <!-- 新闻列表           :to="`/article/${item.art_id.toString()}`"-->
        <van-cell
          v-for="item in list"
          :key="item.id">
          <!--一条新闻的结构-->
          <div class="article_item" @click="$router.push(`/article/${item.id}`)" v-if="item.img_type!=3">
                <div class="title">
                  {{ item.title }}
                </div>
            <div class="img_box" v-if="item.img_type===1">
              <van-image
                width="120px"
                height="90px"
                v-for="(img, i) in item.sources"
                :key="i"
                fit="fill"
                position="left"
                :src="img"
              >
                <template #loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
            </div>

            <div class="img_box" v-else-if="item.img_type===2">
              <van-image
                width="360px"
                height="180px"
                fit="fill"
                :src="item.sources[0]"
              >
                <template #loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
            </div>
            <div class="info_box">
              <span v-if="item.is_hot===1" class="is-hot">热点</span>
              <span>{{item.aouther}}</span>
              <span>{{ item.read_num }}阅读</span>
              <span>{{ item.updatetime }}</span>
            </div>
          </div>
          <div class="article_item article_item_sytle2" @click="$router.push(`/article/${item.id}`)" v-else>
             <div class="img_box">
            <div class="layout-single-image-l">
               <div class="title">
                {{ item.title }}
                </div>
                <div class="info_box">
                    <span v-if="item.is_hot===1" class="is-hot">热点</span>
                    <span>{{item.aouther}}</span>
                    <span>{{ item.read_num }}阅读</span>
                    <span>{{ item.updatetime }}</span>
                </div>
            </div>

              <van-image
                width="120px"
                height="90px"
                fit="fill"
                position="right"
                :src="item.sources[0]"
              >
                <template #loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
            </div>
          </div>

        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
/**
 * 记录被缓存组件滚动位置：
 * 1. 给列表绑定滚动事件=》获取滚动高度，存储到变量上
 * 2. 在切换页面后，再次回来=》通过上次记录滚动高度，获取到列表DOM对象，滚动到记录位置
 */
// import MoreAction from './MoreAction.vue'
import { getArticleList } from '@/api/home'
import { getBannerApi } from "../../../api/home";
export default {
  props: {
    channelId: {
      type: Number,
      default: 0
    }
  },
  components: {
    // MoreAction
  },
  data () {
    return {
      list: [],
      loading: false,
      bannerLists: [],
      bannerHeight:'160px',
      bannerStatus:false,
      finished: false,
      refreshing: false,
      timestamp: Date.now(),
      scrollTop: 0, // 列表滚动高度
      isShow: false, // 控制弹层是否显示
      artId: '' ,// 文章ID
      page:1
    }
  },
  methods: {
  async getBnnerList() {
      const { data } = await getBannerApi();
      if(data.length > 0){
        this.bannerStatus=true;
          data.forEach(item=>{
          this.bannerLists.push({
              'img_url':'http://shenghuoribao.oss-cn-beijing.aliyuncs.com'+item.img_uri,
              'jump_url':item.jump_uri
          })
        })
      }
    },
    // 频道
    async onLoad () {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      // 每次加载的条数
      const { data } = await getArticleList({
        cat_id: this.channelId,
        // timestamp: this.timestamp,
        page:this.page
      })
      this.list.push(...data.list)
      this.loading = false
      if (data.list.length>0) {
          this.page++
      } else {
          this.finished = true
      }
    },
  
    bannerTo(url){
      window.location.href = url;
    } ,
    // 下拉刷新 向下拖拽列表手放开才会触发刷新
    onRefresh () {
      // 清空列表数据 统一处理列表的加载完成状态(重置状态，加载完了没加载完)
      this.finished = false
      // 刷新需要重置时间戳=>为当前时间!!!
      this.timestamp = Date.now()
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
      
    },
    // 记忆滚动
    rememberPos (e) {
      // console.log('滚动高度：', e.target.scrollTop)
      this.scrollTop = e.target.scrollTop
    },
    // 执行滚动的方法=》滚动到指定位置 articleList组件激活时=》activated钩子中执行=》滚动列表的方法
    // 根据记录滚动到上次浏览位置
    scrollList () {
      this.$refs.scrollList.scrollTop = this.scrollTop
    },
    // 删除不感兴趣文章
    delDlike () {
      const index = this.list.findIndex(item => item.art_id === this.artId)
      this.list.splice(index, 1)
    },
    /**
     * artId 当前点击操作文章ID
     */
    openAction (artId) {
      console.log(artId)
      this.artId = artId
      this.isShow = true
    },
    handlerPopup (isShow) {
      console.log('子传父：', isShow)
      this.isShow = isShow
    }
  },
  activated () {
    this.scrollList()
  },
  deactivated () {
  },
  created () {
    this.onLoad();
  },
  mounted () {
    this.getBnnerList();
  }
}
</script>

<style lang="less" scoped>
.layout-single-image-l{
    box-sizing: border-box;
    flex-direction: column;
    padding-right: 0.24rem;
    display: flex;
    -webkit-justify-content: space-between
}
.article_item {
  .title{
    color: #222;
    font-size: .5rem;
    line-height: .7rem;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    }
  .img_box {
    display: flex;
    justify-content: space-between;
    .w33 {
      width: 33%;
      height: 90px;
    }
    .w100 {
      width: 100%;
      height: 180px;
    }
  }
  .info_box {
    color: #999;
    line-height: 2;
    position: relative;
    font-size: 12px;
     .is-hot{
       color: #f85959;
     }
    span {
      padding-right: 10px;
      &.close {
        border: 1px solid #ddd;
        border-radius: 2px;
        line-height: 15px;
        height: 12px;
        width: 16px;
        text-align: center;
        padding-right: 0;
        font-size: 8px;
        position: absolute;
        right: 0;
        top: 7px;
      }
    }
  }
}
</style>
